import * as React from 'react';
import { Header2 } from '@cian/ui-kit';
import { SummaryLayout } from './components/SummaryLayout';
import { SummaryContent } from './components/SummaryContent';

export const SummaryContainer = () => {
  return (
    <SummaryLayout
      title={<Header2 data-testid="summary-title">Стоимость размещения</Header2>}
      content={<SummaryContent />}
    />
  );
};
